import { render, staticRenderFns } from "./vipManage.vue?vue&type=template&id=1244403e&scoped=true&"
import script from "./vipManage.vue?vue&type=script&lang=js&"
export * from "./vipManage.vue?vue&type=script&lang=js&"
import style0 from "./vipManage.vue?vue&type=style&index=0&id=1244403e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244403e",
  null
  
)

export default component.exports